import { useCallback, useEffect, useState } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { css } from '@emotion/react';
import './Style.css';
import ReactModal from 'react-modal';

import { MdKeyboardArrowRight, MdOutlineReportGmailerrorred } from 'react-icons/md';
import { TbCircleCheck, TbCoin, TbKey, TbShare } from 'react-icons/tb';
import { TiContacts } from 'react-icons/ti';

import IntlCurrencyInput from 'react-intl-currency-input';
import BeatLoader from 'react-spinners/BeatLoader';
import HistoricoPixRow from '../historico-pix-row/HistoricoPixRow';
import { FilterItemMfaGeneral } from '../../../E-check/style';

import bankList from '../../../../services/bankList.json';
import { apiV1 } from '../../../../lib/axios';
import { getPixInfo, listContacts, listPix, sendPixFitBank } from '../../../../services/pix.service';
import { sendTransactionMfa } from '../../../../services/mfa.service';
import { useAccount } from '../../../../hooks/useAccount';
import { useAuth } from '../../../../hooks/useAuth';

import { hideTaxNumber } from '../../../../utils/formatter';
import { identificarTipoChavePix } from '../../../../utils/identificarTipoChavePix';
import { Input } from '../../../Input';
import TransactionUsageBox from '../../../TransactionUsageBox/TransactionUsageBox';
import { userHasPermission } from '../../../../utils/verifyUserPermission';
import { companyUserPermissions } from '../../../../enums/companyUserPermissions';
import pendingIcon from '../../../../assets/image/pending-icon.svg';

export default function () {
  const [valor, setValor] = useState(0);
  const [descricao, setDescricao] = useState('');
  const [chave, setChave] = useState('');
  const [response, setResponse] = useState({});
  const [mfaRequired, setMfaRequired] = useState(false);
  const [isInvalidKey, setIsInvalidKey] = useState(false);
  const [recentPixes, setRecentPixes] = useState();
  const [contacts, setContacts] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  const [isFavorite, setIsFavorite] = useState(false);
  const [alreadyInFavorites, setAlreadyInFavorites] = useState(false);
  const [receipt, setReceipt] = useState(false);
  const [preReceipt, setPreReceipt] = useState();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [sendPixLoader, setSendPixLoader] = useState(false);
  const [getInfoLoader, setGetInfoLoader] = useState(false);
  const [historicLoader, setHistoricLoader] = useState(false);
  const [mfaCode, setMfaCode] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [pixUsage, setPixUsage] = useState();
  const [voucherUrl, setVoucherUrl] = useState(null);

  const location = useLocation();
  const { user, getProfile } = useAuth();
  const { avaliableBalance, getBalance } = useAccount();


  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    display: flex;
  `;

  const currencyConfig = {
    locale: 'pt-BR',
    formats: {
      number: {
        BRL: {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const isTestUser = () => user.taxNumber === '12345678900';

  const getBankName = (bankCode) => {
    const bank = bankList.find((item) => item.code == bankCode);
    return bank ? bank.name : '';
  };

  const getInitials = useCallback((name) => {
    const words = name.split(' ');
    if (words.length > 1) {
      return words[0][0] + words[1][0];
    }
    return words[0][0];
  }, []);

  const isInvalidPixKey = (chave) => !chave;
  
  const isInvalidAmount = () => {
    if (!valor) {
      setErrorMessage('Digite o valor.');
      return true;
    }
    return false;
  };
  
  const isExceedingBalance = () => {
    if (Number(valor)  + Number(pixUsage?.tax) > Number(avaliableBalance)) {
      setErrorMessage('O valor excede o saldo disponível.');
      return true;
    }
    return false;
  };

  const isEmptyMfaCode = () => {
    if (!mfaCode.trim()) {
      toast.error('Código MFA não pode estar vazio');
      return true;
    }
    return false;
  };

  const handleChange = (event, value) => {
    event.preventDefault();
    setErrorMessage('');
    setValor(value);
  };

  const handleClick = useCallback(async () => {
    await sendTransactionMfa();
    setIsDisabled(true);
    setCountdown(40);
  
    const interval = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          clearInterval(interval);
          setIsDisabled(false);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);
  }, []);

  const handleContactOnClick = (item) => {
    if(getInfoLoader) return;

    setAlreadyInFavorites(true);
    getInfos(item.key);
  };

  const closeModal = useCallback(() => {
    setIsOpenModal(false);
    setPreReceipt(undefined);
    setReceipt(undefined);
    setMfaRequired(false);
    setChave('');
    setValor(0);
    setGetInfoLoader(false);
    setSendPixLoader(false);
  }, []);

  async function verifyFavorite(data) {
    const response = await listContacts();

    if (!response?.data?.length) return;

    const contacts = response.data;

    const alreadyFavorite = contacts.find(
      (item) => item.key === data.PixKeyValue
    );

    setAlreadyInFavorites(alreadyFavorite);
  }

  const handleTestUser = () => {
    setPreReceipt({
      ReceiverBankName: 'Nu Pagamentos S.A',
      ReceiverName: 'Conta Teste',
      ReceiverISPB: '18236120',
      ReceiverBank: '260',
      ReceiverBankBranch: '1',
      ReceiverBankAccount: '1231232',
      ReceiverBankAccountDigit: '3',
      ReceiverAccountType: '1',
      PixKeyType: '1',
      PixKeyValue: '12345678900',
      ReceiverTaxNumber: '12345678900',
    });
    setIsOpenModal(true);
    setGetInfoLoader(false);
    setIsInvalidKey(false);
  };

  const fetchPixInfo = async (chave) => {
    const response = await getPixInfo(chave, identificarTipoChavePix(chave));
    return response.data.data;
  };

  const handleSuccess = () => {
    setIsOpenModal(true);
    setGetInfoLoader(false);
    setIsInvalidKey(false);
  };
  
  const handleError = () => {
    setGetInfoLoader(false);
    setIsInvalidKey(true);
  };

  const handleSendPixError = (err) => {
    toast.error(err.response.data.message);
  };

  const handleTestUserTransaction = () => {
    setResponse({
      toName: 'Teste',
      toBank: '260',
      toTaxNumber: '16440384716',
    });
    setReceipt(true);
  };

  const createSendPixRequestBody = () => {
    return {
      value: valor,
      description: descricao,
      keyType: preReceipt.PixKeyType,
      key: preReceipt.PixKeyValue,
      isPixFavorito: isFavorite,
      searchProtocol: preReceipt.searchProtocol,
      otp: mfaCode,
      isMainAccess: user.isMainAccess,
      receiverInfo: {
        name: preReceipt.ReceiverName,
        taxNumber: preReceipt.ReceiverTaxNumber,
        bank: preReceipt.ReceiverBank
      },
    };
  };
 
  const handleTransactionSuccess = async (response) => {
    const pixResponseData = response.data.data;

    setResponse(pixResponseData);
    if(!user.isMainAccess) {
      toast.success('Transação Pix aguardando aprovação!');
    } else {
      await getComprovante( 
        pixResponseData.documentNumber,
        pixResponseData.type,
      );
    }
    setReceipt(true);
  };

  const resetStateAfterTransaction = () => {
    setSendPixLoader(false);
    setMfaRequired(false);
    setMfaCode(null);
  };

  const getInfos = useCallback(async (chave) => {
    if (sendPixLoader) return;

    if (isTestUser()) {
      return handleTestUser();
    }
  
    if (isInvalidPixKey(chave)) {
      toast.error('Insira a chave pix!');
      setGetInfoLoader(false);
      return;
    }
    setGetInfoLoader(true);

    try {
      const preReceipt = await fetchPixInfo(chave);
      setPreReceipt(preReceipt);
      await verifyFavorite(preReceipt);
      handleSuccess();
    } catch (err) {
      handleError(err);
    }
  }, [sendPixLoader, user]);

  const sendPix = useCallback(async () => {
    if (sendPixLoader) return;
    
    setSendPixLoader(true);
    setReceipt('');

    if (isEmptyMfaCode()) return setSendPixLoader(false);
  
    if (isTestUser()) return handleTestUserTransaction();
  
    const body = createSendPixRequestBody();
  
    try {
      const response = await sendPixFitBank(body);

      if (response) await handleTransactionSuccess(response);
      getContacts();

    } catch (err) {
      console.log("err ", err);
      handleSendPixError(err);
      closeModal();
    } finally {
      resetStateAfterTransaction();
      getProfile();
    }
  }, [sendPixLoader, mfaRequired, valor, avaliableBalance, mfaCode, user, preReceipt, isFavorite]);

  const sendMfa = useCallback(async () => {
    if (isInvalidAmount()) return;
    if (isExceedingBalance()) return;
  
    await sendTransactionMfa();
    setMfaRequired(true);
  }, [valor, avaliableBalance]);

  async function getComprovante(documentNumber, type) {
    const response = await apiV1.post('/voucher/fetch', {
      type,
      documentNumber,
    });

    const url = response.data.url;
    localStorage.removeItem('comprovante');
    setVoucherUrl(url);
  }

  const getContacts = async () => {
    const contacts = await listContacts();
    setContacts(contacts.data);
  };

  useEffect(() => {
    const getSentPixs = async () => {
      if (user.taxNumber === '12345678900') {
        setRecentPixes();
        return;
      }
      setHistoricLoader(true);
      const sentPixs = await listPix();
      setRecentPixes(sentPixs.data);
      setHistoricLoader(false);
    };

    if (location.state) {
      if (location.state.pixKey) {
        setChave(location.state.pixKey);
        getInfos(location.state.pixKey);
      } else {
        toast.warn('Falha ao tentar enviar PIX para este contato.');
      }
    }

    getContacts();
    getSentPixs();
  }, [location, toast]);

  const navigate = useNavigate();
  useEffect(() => {
    if (!avaliableBalance) {
      getBalance();
    }
  }, []);

  useEffect(() => {
    if (!(user && Object.keys(user).length > 0)) return;
    
    if(!userHasPermission(user, companyUserPermissions.SEND_PIX)) {
      toast.error('Você não tem permissão para acessar esta funcionalidade.');
      navigate('/pagina-pix');
    }

    if (user?.accountTransactionUsages?.PIX) {
      const { used, free, remaining, tax } = user.accountTransactionUsages.PIX;
      setPixUsage({ used, free, remaining, tax });
    }
  }, [user]);

  const renderHeader = () => (
    <div className="header">
      <div className="col-xl-12">
        <label>
          <Link to={'/pagina-principal'}>
            Pagina inicial
            <MdKeyboardArrowRight size={20} />
          </Link>
          <Link to={'/pagina-pix'}>
            Área Pix
            <MdKeyboardArrowRight size={20} />
          </Link>
          Transferência Pix
        </label>
        <p>Transferência Pix</p>
      </div>
    </div>
  );

  const renderPixInputForm = () => (
    <div className="col-md-12 d-flex align-items-end gap-4">
      <div className="col-md-6">
        <label>Chave Pix</label>
        <div className={`input-area ${isInvalidKey ? 'invalid-input' : ''}`}>
          <div className="input-area-icon">
            <TbKey size={18} />
          </div>
          <div className="col-md-11">
            <input
              type="text"
              value={chave}
              placeholder="CPF, CNPJ, Celular ou Chave Aleatória"
              onChange={(e) => setChave(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="col-md-6 d-flex gap-3">
        <button disabled title="Em Breve" className="btn-contatos-disabled">
          <TiContacts size={16} />
          Contatos
        </button>
        <button disabled={getInfoLoader} onClick={() => getInfos(chave)}>
          {getInfoLoader ? (
            <BeatLoader
              color="var(--text-primary)"
              loading={getInfoLoader}
              css={override}
              size={20}
            />
          ) : (
            'Prosseguir'
          )}
        </button>
      </div>
    </div>
  );

  const renderErrorMessage = () => (
    <label className={`error-message ${isInvalidKey ? 'invalid' : 'valid'}`}>
      <MdOutlineReportGmailerrorred size={14} />
      Chave pix não identificada
    </label>
  );

  const renderContacts = () => (
    <div className="col-md-12 mt-5">
      <h2>Contatos Recentes</h2>
      <div className="d-flex">
        {contacts &&
          contacts.map((item, index) => (
            <div
              className="recent-card"
              key={index}
              onClick={() => handleContactOnClick(item)}
            >
              <div className="recent-icons">{getInitials(item.name)}</div>
              <div className="recent-content">
                <p>{item.name}</p>
                <span>{item.bank}</span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );

  const renderTransactionHistory = () => (
    <div className="footer">
      <h2>Últimas Transações</h2>
      <div className="historico-area">
        {recentPixes &&
          recentPixes.map((item) => (
            <HistoricoPixRow
              key={item.id}
              data={{
                name: item.receiverName,
                taxNumber: item.receiverTaxNumber,
                date: item.date,
                value: item.value,
                bank: item.receiverBank,
              }}
            />
          ))}
      </div>
    </div>
  );

  const renderModalForm = () => (
    <>
      <div className="pix-modal-header">
        <h1>Dados do Favorecido</h1>
      </div>

      <div className="pix-modal-body">
        <div className="d-flex">
          <div className="col-md-4">
            <label>Nome</label>
            <p>{preReceipt?.ReceiverName}</p>
          </div>
          <div className="col-md-4">
            <label>Instituição de Destino</label>
            <p>
              {preReceipt?.ReceiverBank} -{' '}
              {bankList.find(item => item.code == preReceipt?.ReceiverBank)?.name}
            </p>
          </div>
          <div className="col-md-4">
            <label>CPF/CNPJ do Favorecido</label>
            <p>{hideTaxNumber(preReceipt?.ReceiverTaxNumber)}</p>
          </div>
        </div>

        <div className="col-md-7">
          {!mfaRequired ? (
            <>
              <label>Valor de Transferência</label>
              <div className="input-area input-pix-currency mb-3">
                <div className="input-area-icon col-md-1">
                  <TbCoin size={18} />
                </div>
                <div className="col-md-11">
                  <IntlCurrencyInput
                    currency="BRL"
                    config={currencyConfig}
                    onChange={handleChange}
                    value={valor}
                  />
                </div>
              </div>
              <Input
                type={'text'}
                label={'Descrição'}
                value={descricao}
                onChange={setDescricao}
                placeholder={'Insira uma descrição'}
              />
              {!alreadyInFavorites && (
                <div className="d-flex gap-1 mt-3">
                  <input
                    type="checkbox"
                    id="favoritePix"
                    onChange={() => setIsFavorite(!isFavorite)}
                  />
                  <label htmlFor="favoritePix">Salvar nos contatos</label>
                </div>
              )}
              {errorMessage && (
                <p className="errorMessage">{errorMessage}</p>
              )}

              <TransactionUsageBox usage={pixUsage} type="PIX" />
            </>
          ) : (
            <>
              <label>Código de confirmação</label>
              <div className="input-area">
                <div className="input-area-icon col-md-1">
                  <TbKey size={18} />
                </div>
                <div className="col-md-11">
                  <input
                    type="text"
                    placeholder="Insira o código MFA"
                    value={mfaCode}
                    onChange={(e) => setMfaCode(e.target.value)}
                    required
                  />
                </div>
              </div>
              <FilterItemMfaGeneral>
                {isDisabled && (
                  <p>
                    Você pode solicitar um novo código em 0:{countdown} segundos
                  </p>
                )}
                <button onClick={handleClick} disabled={isDisabled}>
                  Novo Código
                </button>
              </FilterItemMfaGeneral>
              {errorMessage && (
                <p className="errorMessage">{errorMessage}</p>
              )}
            </>
          )}
        </div>
      </div>

      <div className="pix-modal-footer">
        <button className="cancel-button" onClick={closeModal}>
          Cancelar
        </button>
        <button className="confirm-button" onClick={sendMfa} hidden={mfaRequired}>
          Confirmar Pix
        </button>
        <button className="confirm-button" onClick={sendPix} hidden={!mfaRequired}>
          {sendPixLoader ? (
            <BeatLoader
              color="var(--text-primary)"
              loading={sendPixLoader}
              css={override}
              size={20}
            />
          ) : (
            'Confirmar código'
          )}
        </button>
      </div>
    </>
  );

  const renderReceiptModal = () => (
    <>
      <div className="pix-modal-header">
        {user.isMainAccess ? <TbCircleCheck color="#32D16D" size={75} /> : <img src={pendingIcon} style={{ width: '75px', marginBottom: '20px' }} />}
        <h1>{user.isMainAccess ? 'Transferência Pix realizada com sucesso!' : 'Transferência Pix aguardando aprovação!'}</h1>
      </div>

      <div>
        <button className="close-button" onClick={closeModal}>X</button>
      </div>

      <div className="pix-modal-body">
        <div className="d-flex">
          <div className="col-md-4">
            <label>Nome</label>
            <p>{preReceipt?.ReceiverName}</p>
          </div>
          <div className="col-md-4">
            <label>Instituição de Destino</label>
            <p>
              {preReceipt?.ReceiverBank} -{' '}
              {bankList.find(item => item.code == preReceipt?.ReceiverBank)?.name}
            </p>
          </div>
          <div className="col-md-4">
            <label>CPF/CNPJ do Favorecido</label>
            <p>{hideTaxNumber(preReceipt?.ReceiverTaxNumber)}</p>
          </div>
        </div>
      </div>
      {
        user.isMainAccess && 
          <div className="pix-modal-footer">
            <NavLink
              to={voucherUrl}
              target="_blank"
              className="share-button"
            >
              Compartilhar comprovante
              <TbShare size={16} />
            </NavLink>
          </div>
      }
    </>
  );

  return (
    <>
      <div className="transferencia-pix">
        <div className="col-md-10 transferencia-pix-container">
          {renderHeader()}

          <div className="body">
            <div className="col-md-12">
              {renderPixInputForm()}
              {renderErrorMessage()}
              {renderContacts()}
            </div>
          </div>

          {renderTransactionHistory()}
        </div>
      </div>
      
      <ReactModal
        isOpen={isOpenModal}
        className={'pix-modal'}
        overlayClassName={'overlay-pix-modal'}
      >
        {!receipt ? renderModalForm() : renderReceiptModal()}
      </ReactModal>
    </>
  );
}
